import React from 'react'

const Manual_flujo_orden_clau_invu = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Flujo de una orden desde Clau.io a Invu POS
        </h2>
        <iframe
          src="https://scribehow.com/embed/Flujo_de_una_orden_desde_Clau_io_a_Invu_POS__9eq1KdjrQD2fvy4Zztn6nA?as=scrollable"
          className="scribe-iframe-general-70"
          width="100%"
          height="7000"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_flujo_orden_clau_invu
